import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import utc from 'dayjs/plugin/utc';

import {
  DATE_FORMAT,
  TIME_FORMAT,
  TIME_FORMAT_SEC
} from '@/constants/date.constants';

dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(utc);

export default function getDateTime(date: string, withSeconds = false) {
  const dayjsObject = dayjs.utc(date);

  // date that matches todays date
  if (dayjsObject.local().isToday()) {
    return `Today, ${dayjsObject.local().format(withSeconds ? TIME_FORMAT_SEC : TIME_FORMAT)}`;
  }

  // date that matches yesterdays date
  if (dayjsObject.local().isYesterday()) {
    return `Yesterday, ${dayjsObject.local().format(withSeconds ? TIME_FORMAT_SEC : TIME_FORMAT)}`;
  }

  // all other dates not today or yesterday
  return `${dayjsObject.local().format(DATE_FORMAT)}, ${dayjsObject
    .local()
    .format(withSeconds ? TIME_FORMAT_SEC : TIME_FORMAT)}`;
}
